/**
 * utils/clock.ts
 *
 * Shared clock abstraction for MER Algo Footprints.
 *
 * Centralises all time-source access in core logic.
 * Default implementation uses Date.now().
 * Override with setClock() for deterministic testing.
 * Restore with resetClock().
 *
 * Usage in core logic:
 *   import { now } from '../utils/clock';
 *   const ts = now();
 */

let _clock: () => number = Date.now.bind(Date);

/** Returns current time in milliseconds. Default: Date.now(). */
export function now(): number {
  return _clock();
}

/** Override the clock implementation (e.g. for testing). */
export function setClock(fn: () => number): void {
  _clock = fn;
}

/** Restore the default Date.now() clock. */
export function resetClock(): void {
  _clock = Date.now.bind(Date);
}
